import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'
import { AircraftFeeRouter } from './aircraft-fee/_router'
import { AircraftRateRouter } from './aircraft-rate/_router'
import { AircraftStatementRouter } from './aircraft-statement/_router'
import { DisputesRouter } from './disputes/_router'
import { LegalTermsVersionRouter } from './legal-terms-version/_router'
import { PaymentRouter } from './payment/_router'
import { PaymentMeanRouter } from './payment-mean/_router'
import { PurchaseRouter } from './purchase/_router'
import { SaleRouter } from './sale/_router'
import { StockRouter } from './stock/_router'

const Index = lazy(() => import('./Index'))

export const AccountingRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting']}>
    <Route index element={<Index />} />
    <Route path='purchase/*' element={<PurchaseRouter />} />
    <Route path='sale/*' element={<SaleRouter />} />
    <Route path='disputes/*' element={<DisputesRouter />} />
    <Route path='payment/*' element={<PaymentRouter />} />
    <Route path='payment-mean/*' element={<PaymentMeanRouter />} />
    <Route path='aircraft-rate/*' element={<AircraftRateRouter />} />
    <Route path='aircraft-statement/*' element={<AircraftStatementRouter />} />
    <Route path='aircraft-fee/*' element={<AircraftFeeRouter />} />
    <Route path='legal-terms-version/*' element={<LegalTermsVersionRouter />} />
    <Route path='stock/*' element={<StockRouter />} />
  </SubRouter>
))
